import { render, staticRenderFns } from "./CoachContentLabel.vue?vue&type=template&id=3705c385&scoped=true&"
import script from "./CoachContentLabel.vue?vue&type=script&lang=js&"
export * from "./CoachContentLabel.vue?vue&type=script&lang=js&"
import style0 from "./CoachContentLabel.vue?vue&type=style&index=0&id=3705c385&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3705c385",
  null
  
)

component.options.__file = "CoachContentLabel.vue"
export default component.exports